import dayjs from 'dayjs';

import { TargetDomain } from '../types';
import { decodeUser } from './decode-user';
import { refreshJwt } from './refresh-jwt';
import { getJwt } from './tokens';

/**
 * This function returns the current JWT in cookies, unless it's outdated
 * in which case it fetches a new one
 */
export async function getLatestJwt(
  authHost: string,
  targetDomain: TargetDomain,
): Promise<string | undefined> {
  const token = getJwt();
  if (token != null) {
    const decodedUser = decodeUser(token);
    if (decodedUser == null) {
      return;
    }

    const isExpired = dayjs.unix(decodedUser.exp).isSameOrBefore(dayjs());

    if (isExpired) {
      return await refreshJwt(authHost, targetDomain);
    } else {
      return token;
    }
  }
}
